import React, { FunctionComponent } from 'react';

import { useEvent } from 'effector-react/ssr';

import clsx from 'clsx';

import { setIsOpenCatalogMenu } from '@stores/header';

import { Button } from '@components/common/Button/Button';

import styles from './MenuButton.module.scss';

type MenuButtonProps = {
    isOpenMenu: boolean;
};

export const MenuButton: FunctionComponent<MenuButtonProps> = (props) => {
    const { isOpenMenu } = props;

    const setIsOpenCatalogMenuFn = useEvent(setIsOpenCatalogMenu);

    const onButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        // Prevent closing catalog widgets by useClickOutside
        event.stopPropagation();
        setIsOpenCatalogMenuFn(!isOpenMenu);
    };

    return (
        <Button
            onClick={onButtonClick}
            className={styles.root}
            variant="greenLight"
            aria-label={isOpenMenu ? 'Закрыть каталог' : 'Открыть каталог'}
        >
            <div className={clsx(styles.icon, isOpenMenu && styles.isActive)}>
                <div />
            </div>
        </Button>
    );
};
